export const validatorTypes = {
  fileTypeValidator: 'FILE_TYPE_VALIDATOR',
  resolutionValidator: 'RESOLUTION_VALIDATOR',
  spotColorsValidator: 'SPOT_COLOURS_VALIDATOR',
  maxNumberOfColoursValidator: 'MAXIMUM_NUMBER_OF_COLOURS',
  collisionDetection: 'COLLISION_DETECTION',
  vectorFileValidator: 'VECTOR_FILE_VALIDATOR',
  smallDetails: 'SMALL_DETAILS_VALIDATOR',
  commercialRemark: 'COMMERCIAL_REMARK',
} as const;

export type vt = typeof validatorTypes;
export type ValidatorTypeType = keyof vt;
export type ValidatorValueType = vt[keyof vt];
